import React, { useEffect, useState } from "react";
import { DatePicker, Flex, Form, message, Typography } from "antd";
import { Input, Button } from "antd";
import emailjs from '@emailjs/browser';


const { Title } = Typography;

const Forms = ({ handleCancel }) => {

  const [form] = Form.useForm();
  const [clientReady, setClientReady] = useState(false);
  const [mobileOtp, setMobileOtp] = useState(false);

  // ================== FORM INPUTS ===================

  const [formDetails, setFormDetails] = useState({
    name: "",
    city: "",
    email: "",
    mobile: "",
    destination: "",
    date: "",
    people: "",
  });

  const handleMobileOtpToggle = () => {
    setMobileOtp(!mobileOtp);
  };

  const [loading, setIsLoading] = useState(false)
  const [date, setDate] = useState('')

  const onFormChange = (e) => {
    const { name, value } = e.target;
    setFormDetails((state) => ({ ...state, [name]: value }));
  };

  const onChange = (date, dateString) => {
    setDate(dateString)
  };

  // To disable submit button at the beginning.
  useEffect(() => {
    setClientReady(true);
  }, [clientReady]); // Include clientReady in the dependency array

  const handleSubmit = (e) => {
    // e.preventDefault();
    //setIsLoading(true)
    const templateParams = {
      name: formDetails.name,
      city: formDetails.city,
      email: formDetails.email,
      mobile: formDetails.mobile,
      destination: formDetails.destination,
      date: date,
      people: formDetails.people
    };



    emailjs
      .send("service_aq8tecc", "template_ulhaktq", templateParams, "E5o5q3VioEguQikrN")
      .then(
        () => {
          console.log("SUCCESS!");
          //setIsSubmitted(true); // Update the state to show success message
          setIsLoading(false); // Stop loading
          form.resetFields();
          setFormDetails({
            name: "",
            city: "",
            email: "",
            mobile: "",
            destination: "",
            people: "",
          });
          setDate("");
          handleCancel();
          message.open({
            type: 'success',
            content: 'Mail Send SuccessFully',
          });
        },
        (error) => {
          console.error("FAILED...", error); // Log the error for debugging
          setIsLoading(false); // Stop loading
          message.open({
            type: 'error',
            content: 'Something Went Wrong Please Try Again Later',
          });
        }
      );
  };

  return (

    <Flex className="login-content" vertical justify="center" align="middle">
      {/* <button onClick={handleClick}>123</button> */}
      <div className="login-header">
        {/* <img src={Images.ClientLogo} alt="logo" width={150} height={50} /> */}
        <Title className="login-heading" level={3}>
          Enquire Now
        </Title>
      </div>
      <Form
        //disabled={true}
        form={form}
        onFinish={handleSubmit}
        autoComplete="off"
        className="cardlogin"
        layout="vertical"
      >
        <Form.Item
          label="Name"
          name="name"
          className="login-input-label"
          rules={[{ required: true, message: "Please input your Name!" }]}
        >
          <Input
            className="login-input"
            size="large"
            name="name"
            value={formDetails.name}
            //   prefix={<ContactsOutlined />}
            placeholder="Name"
            onChange={onFormChange}
          />
        </Form.Item>

        <Form.Item
          label="City"
          name="city"
          className="login-input-label"
          rules={[{ required: true, message: "Please input your City!" }]}
        >
          <Input
            className="login-input"
            size="large"
            name="city"
            value={formDetails.city}
            //   prefix={<UserOutlined />}
            placeholder="City"
            onChange={onFormChange}
          />
        </Form.Item>
        <Form.Item
          label="Email"
          name="email"
          className="login-input-label"
          rules={[{ required: true, message: "Please input your Email!" }]}
        >
          <Input
            className="login-input"
            size="large"
            name="email"
            value={formDetails.email}
            //   prefix={<LockOutlined />}
            placeholder="Email"
            onChange={onFormChange}
          />
        </Form.Item>

        <Form.Item
          label="Mobile"
          name="mobile"
          className="login-input-label"
          rules={[{ required: true, message: "Please input your Mobile No!" }]}
        >
          <Input
            className="login-input"
            size="large"
            name="mobile"
            value={formDetails.mobile}
            //   prefix={<LockOutlined />}
            placeholder="Mobile"
            onChange={onFormChange}
          />
        </Form.Item>

        <Form.Item
          label="Travel Destination"
          name="destination"
          className="login-input-label"
          rules={[{ required: true, message: "Please input your Travel Destination!" }]}
        >
          <Input
            className="login-input"
            size="large"
            name="destination"
            value={formDetails.destination}
            //   prefix={<LockOutlined />}
            placeholder="Travel Destination"
            onChange={onFormChange}
          />
        </Form.Item>

        <Form.Item
          label="Date of Travel"
          name="date"
          className="login-input-label"
          rules={[{ required: true, message: "Please input your Date!" }]}
        >
          <DatePicker
            className="login-input"
            size="large"
            name="date"
            style={{ width: "100%" }}
            value={date}
            //   prefix={<LockOutlined />}
            placeholder="Date of Travel"
            onChange={onChange}
          />
        </Form.Item>

        <Form.Item
          label="No of people"
          name="people"
          className="login-input-label"
          rules={[{ required: true, message: "Please input your Count!" }]}
        >
          <Input
            className="login-input"
            size="large"
            name="people"
            value={formDetails.email}
            //   prefix={<LockOutlined />}
            placeholder="No of People"
            onChange={onFormChange}
          />
        </Form.Item>





        <Form.Item style={{ textAlign: "center", marginBottom: "12px" }}>
          <Button
            //width={"100%"}
            className="active-button"
            type="primary"
            loading={loading}
            htmlType="submit"

            block
          >
            Submit
          </Button>
        </Form.Item>
      </Form>
    </Flex>

  )
}

export default Forms